module.exports = __webpack_public_path__ + "img/hammer.724002a3.svg";